export const NOTIFICATIONS_CHANGED_EVENT = 'wfm-notifications-changed';

export const INTERNAL_ROUTE_PREFIXES = [
  '/home',
  '/rubrica',
  '/dashboard',
  '/pratiche',
  '/bundle',
  '/fermo-tecnico',
  '/storico',
  '/profilo',
  '/notifiche',
  '/news',
  '/effeisbuck',
  '/helpdesk',
  '/admin',
  '/workforce',
  '/iam',
  '/config',
  '/onboarding',
];

export function notificaCambioNotifiche() {
  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function') {
    window.dispatchEvent(new CustomEvent(NOTIFICATIONS_CHANGED_EVENT));
  }
}

export function isPercorsoInternoWfm(pathname) {
  if (typeof pathname !== 'string' || !pathname.startsWith('/')) return false;
  if (pathname === '/') return true;
  return INTERNAL_ROUTE_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`)
  );
}

export function deduciPercorsoNotificaLegacy(notification) {
  const title = typeof notification?.title === 'string' ? notification.title.trim() : '';
  if (!title) return null;

  const hdMatch = title.match(
    /^(?:Ti è stato assegnato il ticket|Stato ticket|Ticket risolto:|Ticket riaperto:|Promemoria ticket|SLA (?:SCADUTA|in scadenza)\s*[-—]|(?:Nota interna|Nuovo commento) su|Sei stato menzionato (?:nel ticket|in un commento HELPDESK))\s*\(?([A-Za-z0-9]+-\d+)\)?/i
  );
  if (hdMatch) return `/helpdesk/tickets/${hdMatch[1]}`;

  if (/menzionato in un (?:post|commento) EFFEISBUCK/i.test(title)) {
    return '/effeisbuck';
  }
  if (/^(?:Reminder Target|Target .+ non raggiunto|Target a rischio)/i.test(title)) {
    return '/pratiche';
  }
  if (/^Import CSV:/i.test(title)) {
    return '/admin/moduli';
  }
  if (/^Ore (?:eccedenti da approvare|supplementari e straordinarie da rivedere):/i.test(title)) {
    return '/workforce/banca-ore';
  }
  if (/^Saldo negativo dopo il ricalcolo:/i.test(title)) {
    return '/workforce/saldi';
  }
  if (/maturazione mensile/i.test(title)) {
    return '/workforce/maturazioni';
  }

  return null;
}

export function risolviDestinazioneNotifica(notification, currentOrigin = '') {
  const raw = typeof notification?.link === 'string' ? notification.link.trim() : '';

  if (raw && !/^(?:javascript|data|vbscript):/i.test(raw)) {
    if (raw.startsWith('/') && !raw.startsWith('//')) {
      return { kind: 'internal', to: raw, explicit: true };
    }

    let parsedUrl = null;
    try {
      parsedUrl = new URL(raw);
    } catch {
      parsedUrl = null;
    }

    if (parsedUrl) {
      if (parsedUrl.protocol === 'http:' || parsedUrl.protocol === 'https:') {
        const internalPath = `${parsedUrl.pathname}${parsedUrl.search}${parsedUrl.hash}` || '/';
        if ((currentOrigin && parsedUrl.origin === currentOrigin) || isPercorsoInternoWfm(parsedUrl.pathname)) {
          return { kind: 'internal', to: internalPath, explicit: true };
        }
        return { kind: 'external', href: parsedUrl.toString(), explicit: true };
      }
    } else if (!raw.startsWith('//') && !/^[a-zA-Z][a-zA-Z0-9+.-]*:/.test(raw)) {
      const normalized = `/${raw.replace(/^\/+/, '')}`;
      const pathname = normalized.split(/[?#]/)[0];
      if (isPercorsoInternoWfm(pathname)) {
        return { kind: 'internal', to: normalized, explicit: true };
      }
    }
  }

  const inferred = deduciPercorsoNotificaLegacy(notification);
  if (inferred) {
    return { kind: 'internal', to: inferred, explicit: false };
  }

  return {
    kind: 'fallback',
    to: notification?.id ? `/notifiche#notif-${notification.id}` : '/notifiche',
    explicit: false,
  };
}

export function apriDestinazioneNotifica(notification, navigate, options = {}) {
  const {
    includeFallback = true,
    currentOrigin = typeof window !== 'undefined' && window.location ? window.location.origin : '',
    openExternal = (href) => {
      if (typeof window !== 'undefined' && typeof window.open === 'function') {
        window.open(href, '_blank', 'noopener,noreferrer');
      }
    },
  } = options;

  const dest = risolviDestinazioneNotifica(notification, currentOrigin);

  if (dest.kind === 'external') {
    openExternal(dest.href);
    return dest;
  }

  if (dest.kind === 'internal' || (dest.kind === 'fallback' && includeFallback)) {
    if (typeof navigate === 'function') {
      navigate(dest.to, {
        state: {
          fromNotificationId: notification?.id || null,
          fromNotificationAt: Date.now(),
        },
      });
    }
  }

  return dest;
}
